module.exports = __webpack_public_path__ + "static/img/4.b67bf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/4.png
// module id = xw9h
// module chunks = 1